/* Devis Collection Handler v4 — Codex 2026-07-03 */
(function() {
  var FULL_DEVIS_COLLECTIONS = ['portique-lavage-auto', 'structures-constructions'];
  var BKF_QUOTE_HANDLES = [
    'station-de-lavage-modulaire-bkf-jusqua-4-pistes-par-module-bkf-carwash',
    'station-de-lavage-container-bkf-solution-transportable-cle-en-main-bkf-carwash',
    'station-de-lavage-bkf-nexo-construction-nouvelle-generation-bkf-carwash',
    'station-de-lavage-bkf-trixo-construction-compacte-et-polyvalente-bkf-carwash',
    'station-de-lavage-bkf-lumi-design-lumineux-et-moderne-bkf-carwash',
    'station-de-lavage-bkf-premium-construction-haut-de-gamme-acier-galvanise-bkf-carwash',
    'station-de-lavage-bkf-basic-construction-acier-galvanise-cle-en-main-bkf-carwash'
  ];

  function currentPath() {
    return window.location.pathname || '';
  }

  function isFullDevisCollection() {
    var path = currentPath();
    for (var i = 0; i < FULL_DEVIS_COLLECTIONS.length; i++) {
      if (path.indexOf('/collections/' + FULL_DEVIS_COLLECTIONS[i]) !== -1) return true;
    }
    return false;
  }

  function isBkfCollection() {
    return currentPath().indexOf('/collections/bkf') !== -1;
  }

  function hasQuoteHandle(item) {
    var links = item.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href') || '';
      for (var j = 0; j < BKF_QUOTE_HANDLES.length; j++) {
        if (href.indexOf('/products/' + BKF_QUOTE_HANDLES[j]) !== -1) return true;
      }
    }

    return /BKF\s+Charpente/i.test(item.textContent || '');
  }

  function shouldApply(item) {
    if (isFullDevisCollection()) return true;
    if (isBkfCollection()) return hasQuoteHandle(item);
    return false;
  }

  function productUrl(item) {
    var link = item.querySelector('a.product-item__title, a.spf-product-card__title, a[href*="/products/"]');
    return link ? link.getAttribute('href') : '/pages/contact';
  }

  function hidePriceAndCart(item) {
    var priceSelectors = [
      '.product-item__price-list',
      '.price-list',
      '.price',
      '.spf-product-card__price-wrapper',
      '.spf-product-card__price',
      '.spf-product__price',
      '.money'
    ];
    var cartSelectors = [
      'form[action*="/cart/add"]',
      '.product-item__action-list',
      '.product-item__action-btn',
      '.spf-product-card__actions',
      '.spf-product__form'
    ];

    item.querySelectorAll(priceSelectors.join(',')).forEach(function(el) {
      el.textContent = '';
      if (el.parentNode) el.parentNode.removeChild(el);
    });

    item.querySelectorAll(cartSelectors.join(',')).forEach(function(el) {
      el.style.display = 'none';
      el.setAttribute('aria-hidden', 'true');
    });
  }

  function insertQuoteUi(item) {
    if (item.querySelector('.devis-price-label')) return;
    var area = item.querySelector('.product-item__info, .product-item__info-inner, .spf-product-card__content, .spf-product-card__info') || item;
    var url = productUrl(item);

    var label = document.createElement('div');
    label.className = 'devis-price-label';
    label.textContent = 'Sur demande de devis';

    var btn = document.createElement('a');
    btn.href = url;
    btn.className = 'devis-cta-btn';
    btn.textContent = 'Demander un devis';

    area.appendChild(label);
    area.appendChild(btn);
  }

  function applyDevisMode() {
    if (!isFullDevisCollection() && !isBkfCollection()) return;

    var items = document.querySelectorAll('.product-item, .product-item--vertical, .spf-product-card, [data-product-id]');
    items.forEach(function(item) {
      if (item.classList.contains('devis-done')) return;
      if (!shouldApply(item)) return;
      item.classList.add('devis-done');
      hidePriceAndCart(item);
      insertQuoteUi(item);
    });
  }

  function initStyle() {
    if (document.getElementById('ela-devis-collection-style')) return;
    var style = document.createElement('style');
    style.id = 'ela-devis-collection-style';
    style.textContent = '.devis-price-label{font-weight:700;color:#1e2d7d;margin:8px 0 6px}.devis-cta-btn{display:inline-flex;align-items:center;justify-content:center;margin-top:6px;padding:9px 12px;background:#cc0000;color:#fff!important;text-decoration:none;font-weight:700;font-size:13px;border-radius:3px;text-align:center}.devis-cta-btn:hover{background:#a80000;color:#fff!important}';
    document.head.appendChild(style);
  }

  function init() {
    initStyle();
    applyDevisMode();
    var observer = new MutationObserver(function() { setTimeout(applyDevisMode, 100); });
    var target = document.querySelector('#Collection, #MainContent, main, .collection, body');
    if (target) observer.observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  setTimeout(applyDevisMode, 500);
  setTimeout(applyDevisMode, 1500);
  setTimeout(applyDevisMode, 3000);
  setTimeout(applyDevisMode, 5000);
})();